export const FETCH_ALL_FULFILLED = 'searchBar/FETCH_ALL_FULFILLED'
export const FETCH_ALL_FAILED = 'searchBar/FETCH_ALL_FAILED'
export const FETCH_ALL_PENDING = 'searchBar/FETCH_ALL_PENDING'

export const SET_SEARCH_VALUE = 'searchBar/SET_SEARCH_VALUE'
export const CLEAR_ALL_RESULTS = 'searchBar/CLEAR_ALL_RESULTS'